import { useLocale } from "@hooks";
import { SortBy, SortOrder, useGetCustomerConsultantMatchingQuery } from "@graphql";
import { PlainLink, Spinner } from "@common";
import { store } from "@store";
import { CONSULTANT_SLIDER, ConsultantProfileLocation } from "@navigation";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  customerId: string;
};

export function BookingMatching(props: Props) {
  const { locale } = useLocale();
  const classes = useStyles();

  const matchingQuery = useGetCustomerConsultantMatchingQuery({
    variables: {
      params: {
        customerId: props.customerId
      },
      filter: {},
      limit: 50,
      skip: 0,
      sortBy: SortBy.Relevance,
      sortOrder: SortOrder.Desc
    },
    fetchPolicy: "cache-and-network"
  });

  if (matchingQuery.loading) {
    return <Spinner />;
  }

  if (!matchingQuery.data.consultantMatching.items.length) {
    return <div className={classes.noResults}>{locale.NoSearchResults}</div>;
  }

  const onConsultantClick = (id: string) => {
    store().navigation.open(CONSULTANT_SLIDER, new ConsultantProfileLocation(id));
  };

  return (
    <TableContainer data-test="BookingMatching">
      <Alert severity="info">
        <span
          dangerouslySetInnerHTML={{ __html: locale.consultantMatchingInfoText }}
        ></span>
      </Alert>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={200}>{locale.ConsultantName}</TableCell>
            <TableCell width={200}>{locale["Responsible HBA"]}</TableCell>
            <TableCell>{locale.AreaOfExpertise}</TableCell>
            <TableCell width={150}>{locale.TotalWeeks}</TableCell>
            <TableCell align="right">{locale.hoursWorked}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {matchingQuery.data.consultantMatching.items.map((row) => (
            <TableRow key={row.consultant._id} data-test={row.consultant._id}>
              <TableCell component="th" scope="row">
                <PlainLink
                  variant={"body2"}
                  onClick={() => onConsultantClick(row.consultant._id)}
                >
                  {row.consultant.Name}
                </PlainLink>
              </TableCell>
              <TableCell>{row.consultant.ResponsiblePerson?.Name}</TableCell>
              <TableCell>{row.consultant.AreasOfExpertise.join(", ")}</TableCell>
              <TableCell>{row.weeksTotal}</TableCell>
              <TableCell align="right">{(row.minutesTotal / 60).toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const useStyles = makeStyles(() => ({
  noResults: {
    display: "flex",
    justifyContent: "center"
  }
}));
